import { createContext, useContext } from 'react';

export const ProgressBarContext = createContext(null);

export const useProgressBarContext = () => {
  return useContext(ProgressBarContext);
};
